import classes from './ReportBubble.module.css'
import { ReactComponent as CloseButton } from '../../../../../assests/chat/bina-close-bubble-button.svg';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sessionReported } from '../../../../../store/chatAi-actions';



function ReportBubble(props) {
    const [checkboxState, setCheckboxState] = useState(false)
    const [inputState, setInputState] = useState("")
    const { texts } = useSelector(state => state.translate);

    const dispatch = useDispatch()
    const onReport = () => {
        dispatch(sessionReported(inputState))
        props.onClose()
    }

    return (
        <>
        <div className={classes.Overlay} onClick={props.onClose}></div>
        <div className={classes.ReportBubble}>
            <div className={classes.BubbleTitleLine}>
                <div className={classes.BubbleCloseButton} onClick={props.onClose}>
                    <CloseButton />
                </div>
                <div className={classes.BubbleTitleContainer}>
                    <div className={classes.BubbleTitle}>
                        {texts.abusiveContentTitle}
                    </div>
                </div>
            </div>
            <div className={classes.ReportInputContainer}>
                <div className={classes.ReportInputTitle}>
                    {texts.reportInputTitle}
                </div>
                <div className={classes.ReportInputTextFieldContainer}>
                    <textarea
                        className={classes.ReportInputTextField}
                        type="text"
                        placeholder={texts.reportInputPlaceholder}
                        value={inputState}
                        onChange={(event) => setInputState(event.target.value)}
                    />
                </div>
            </div>
            <div className={classes.ReportText}>
                <span style={{color: "black", textAlign: "right"}}>{texts.consentText}</span>
            </div>
            <div className={classes.ReportConsent}>
                <div className={classes.ReportConsentText}>
                    {texts.consentConfirmation}
                </div>
                <label className={classes.CheckboxContainer}>
                    <input type="checkbox" onChange={event => setCheckboxState(event.target.checked)} id="consentCheckbox" onClick={() => {}}/>
                    <span className={classes.ReportCheckmark}></span>
                </label>
            </div>
            <div className={classes.ReportActions}>
                <button className={classes.ReportButton} disabled={!checkboxState} onClick={onReport}>
                    {texts.report}
                </button>
                <button className={classes.CancelButton} onClick={props.onClose}>
                    {texts.cancellation}
                </button>
            </div>
        </div>
    </>
    );
}

export default ReportBubble;